<mat-datepicker-toggle class="mat-mini-fab mat-elevation-z4" [for]="dp" style="margin-left: 8px">
</mat-datepicker-toggle>
<mat-form-field style="visibility: hidden; height: 1px; position: absolute">
	<input matInput [matDatepicker]="dp" />
</mat-form-field>
<mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event)"
	(monthSelected)="chosenMonthHandler($event, dp)">
</mat-datepicker>
